import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import PropTypes from 'prop-types';

import {
  requestViewAllClassifications,
  requestViewAllCategories,
  requestViewAllTypes,
} from '../../../api/product/product.actions';

import ProductFilter from '../../../components/common/product-filter/ProductFilter';

const ProductFilterContainer = ({ onApplyFiltersClick }) => {
  const { classifications, categories, types } = useSelector(({ product }) => product);
  const currencyCode = useSelector(({ currency }) => currency.currencyCode);

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(requestViewAllClassifications());
  }, [dispatch]);

  const retrieveCategories = (classificationExternalReference) => {
    dispatch(requestViewAllCategories({ classificationExternalReference }));
  };

  const retrieveTypes = (categoryExternalReference) => {
    dispatch(requestViewAllTypes({ categoryExternalReference }));
  };

  return (
    <ProductFilter
      classifications={classifications}
      categories={categories}
      types={types}
      retrieveCategories={retrieveCategories}
      retrieveTypes={retrieveTypes}
      onApplyFiltersClick={onApplyFiltersClick}
      currencyCode={currencyCode}
    />
  );
};

ProductFilterContainer.propTypes = {
  onApplyFiltersClick: PropTypes.func.isRequired,
};

export default ProductFilterContainer;
